export enum DelayTypes {
    FixedValue = 0,
    AttributeValue = 1,
    WorkflowMaxDuration = 2,
    WorkflowStepMaxDuration = 3,
}
